export default __webpack_public_path__ + "icon-licence.png?d368111e763ea032edbf35445d14b20a";